/* eslint-disable */
// @ts-nocheck
// THIS FILE IS GENERATED, DO NOT EDIT!
import * as Urql from 'urql';

import type * as Types from '../../../../../../generated/graphql/types';

export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type SellerReturnPolicyQueryVariables = Types.Exact<{
  sellerContractId: Types.Scalars['Int']['input'];
  platform?: Types.InputMaybe<Types.Scalars['String']['input']>;
  b2b?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  customerId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  text: Types.Scalars['Boolean']['input'];
}>;

export type SellerReturnPolicyQuery = {
  __typename?: 'Query';
  sellerReturnPolicy?: {
    __typename?: 'SellerReturnPolicy';
    customReturnPolicy?: string;
    validated: boolean;
    returnFeesFree: boolean;
    returnWithdrawalLimitInDays: number;
    returnProcessTime: number;
    text?: string;
  };
};

export const SellerReturnPolicyDocument = /*#__PURE__*/ `
    query SellerReturnPolicy($sellerContractId: Int!, $platform: String, $b2b: Boolean, $customerId: Int, $text: Boolean!) {
  sellerReturnPolicy(
    input: {sellerContractId: $sellerContractId, platform: $platform, b2b: $b2b, customerId: $customerId}
  ) {
    customReturnPolicy
    validated
    returnFeesFree
    returnWithdrawalLimitInDays
    returnProcessTime
    text @include(if: $text)
  }
}
    `;

export function useSellerReturnPolicyQuery(
  options: Omit<Urql.UseQueryArgs<SellerReturnPolicyQueryVariables>, 'query'>,
) {
  return Urql.useQuery<
    SellerReturnPolicyQuery,
    SellerReturnPolicyQueryVariables
  >({ query: SellerReturnPolicyDocument, ...options });
}
